import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Proving } from 'model'
import { IDropdownOption, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export type ProvingDetailsOrderIdFormValues = Proving
export class ProvingDetailsOrderIdFormSchema {
  constructor() {
    return Yup.object().shape({
      orderId: Yup.string().required(),
    })
  }
}

export const ProvingDetailsOrderIdForm: React.FunctionComponent<{
  orderIds: any[]
  notification?: boolean
}> = ({ orderIds, notification }) => {
  const { t } = useTranslation()
  return (
    <FormStack>
      {notification && (
        <FieldStack>
          <Label>
            {t(
              'Achtung! Es sind mehrere Einträge ausgewählt! Die Werte werden bei allen ausgewählten Einträgen mit den Werten aus der Formularmaske überschrieben!'
            )}
          </Label>
        </FieldStack>
      )}
      <FieldStack>
        <Label required={true}>{t('field.orderId.label')}</Label>
        <FieldStackItem
          name="orderId"
          label={t('field.orderId.label')}
          isRequired={true}
          render={(fieldProps) => (
            <FormikDropdown
              {...fieldProps}
              options={[
                { key: '', text: t('field.orderId.noOrderId') },
                ...orderIds.map(
                  (orderId) =>
                    ({
                      key: orderId.orderId,
                      text: `${orderId.orderId} - ${
                        orderId.annotation ? `${orderId.annotation} ` : ''
                      }(${orderId.percentage} %)`,
                    } as IDropdownOption)
                ),
              ]}
            />
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
